{
  "switchToDark": "Switch to dark mode",
  "switchToLight": "Switch to light mode",
  "toggleMenu": "Toggle menu",
  "toggleLanguage": "Toggle language",
  "firstPage": "First page",
  "previousPage": "Previous page",
  "nextPage": "Next page",
  "lastPage": "Last page"
}
